import { cx } from "classix"
import cssModule from "~/shared/ui/layouts/main/index.module.scss"
import { Href } from "~/shared/ui"
import { CSSProperties } from "react"

export function LogoCurtain(props: {
	style?: CSSProperties,
	className?: string,
	hideCurtain: boolean,
	href: string,
	logoText: string,
	enableTransition: boolean,
	onClick?: () => void
}) {
	return <div
		style={props.style}
		className={cx(cssModule.logoCurtain, props.hideCurtain && cssModule.hide, props.enableTransition && cssModule.transition, props.className)}
	>
		<Href href={props.href} onClick={props.onClick}>
			<h1>{props.logoText}</h1>
		</Href>
	</div>
}